import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Paper, Typography, CircularProgress, Alert } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useAuth } from '../contexts/SupabaseAuthContext';

const LoginSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser, loading } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    if (!loading && !currentUser) {
      // ユーザー情報が取得できない場合はログイン画面へ
      navigate('/login');
      return;
    }

    if (currentUser) {
      // カウントダウンタイマー
      const interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            navigate('/');
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [currentUser, loading, navigate]);

  if (loading) {
    return (
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
          <Typography variant="body2" sx={{ mt: 2 }}>
            管理者情報を読み込んでいます...
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <CheckCircleIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
          
          <Typography component="h1" variant="h5" gutterBottom>
            管理画面へのログインに成功しました
          </Typography>

          {currentUser && (
            <Box sx={{ mt: 2, mb: 3, textAlign: 'center' }}>
              <Typography variant="body1" gutterBottom>
                ようこそ、{currentUser.full_name || currentUser.email} さん
              </Typography>
              {currentUser.admin_info && (
                <Typography variant="body2" color="text.secondary">
                  権限レベル: {currentUser.admin_info.role === 'super_admin' ? 'スーパー管理者' : '管理者'}
                </Typography>
              )}
            </Box>
          )}

          {error && (
            <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            <Typography variant="body2" color="text.secondary">
              {countdown}秒後にダッシュボードへ移動します...
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default LoginSuccess;